// Reads the custom org_slug claim from a decoded access token (via the SDK's getClaims).
// Non-string/empty/absent → null, so a token issued before the org_slug claim ships simply
// disables the bounce rather than breaking routing.
export function orgSlugFromClaims(claims: { org_slug?: unknown } | null): string | null {
  const slug = claims?.org_slug;
  return typeof slug === 'string' && slug.length > 0 ? slug : null;
}
